import AppointmentIcon from "./AppointmentIcon";

export default AppointmentIcon;

export * from "./AppointmentIcon";
